import ExceptionHandling from './ExceptionHandling.js'
import { useStore, ActionTypes } from "../store";
import instance from './index';
import BranchValidator from '../utils/branchValidator.js';

export default class PosService {

	getItems() {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/pos_initialization';
		return instance()(
			{
				method: 'get',
				url: api,
			}
		).then(res => res.data)
		.catch((e) => ExceptionHandling.HandleErrors(e))
		.finally(() => {
			store.dispatch(ActionTypes.PROGRESS_BAR, false);
		})
	}

	searchtem(keyword) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/search_items';
		const formData = new FormData();
		formData.append('keyword', keyword);

		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}
	searchPosItem(keyword) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/search_pos_items';
		const formData = new FormData();
		formData.append('keyword', keyword);

		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}
	searchPurItem(keyword) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/search_pur_items';
		const formData = new FormData();
		formData.append('keyword', keyword);

		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}


	getPurItems(references) {
		//console.log("PRODUCTS References ",references);
		// SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
	
		const api = '/api/get_pur_items';
		const formData = new FormData();
		formData.append('references', JSON.stringify(references)); // Send as JSON array
	
		return instance()({
			method: 'post',
			url: api,
			data: formData,
		})
		.then(res => res.data)
		.catch((e) => ExceptionHandling.HandleErrors(e))
		.finally(() => {
			store.dispatch(ActionTypes.PROGRESS_BAR, false);
		});
	}
	
	saveItem(postObj,paymentList, stateObj, savedItemList, counterEntry, isToggled, overrideBranchId = null) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/save_pos_receipt';
		const formData = new FormData();
		formData.append('profile_id',postObj.profileID);
		formData.append('payment_list',JSON.stringify(paymentList));
		formData.append('discount',postObj.discount);
		formData.append('total_paid',postObj.totalPaid);
		formData.append('total_tendered',postObj.totalTendered);
		formData.append('total_change',postObj.totalChange);
		formData.append('total_gross_amt',postObj.totalGrossAmt);
		formData.append('total_bill',postObj.totalBill);
		formData.append('total_tax1',postObj.totalTax1);
		formData.append('total_tax2',postObj.totalTax2);
		formData.append('total_tax3',postObj.totalTax3);
		formData.append('total_tax',postObj.totalTax);
		formData.append('description',postObj.description);
		formData.append('payment_method',postObj.paymentMethod);
		formData.append('doctor_details',postObj.doctorDetails);
		formData.append('patient_details',postObj.patientDetails);
		formData.append('status',postObj.status);
		formData.append('type',postObj.type);
		formData.append('search_receipt_no',postObj.searchReceiptNo);
		formData.append('transfer_store_id',stateObj.transferStoreID);
		formData.append('item_list',JSON.stringify(savedItemList));
		formData.append('counter_entry',JSON.stringify(counterEntry));
		formData.append('customer_name',stateObj.selectedProfile);
		formData.append('customer_tel',stateObj.customerTel);
		formData.append('is_toggeled', isToggled); 
		formData.append('disc_type', postObj.discType);
		formData.append('invoice_discount', postObj.invoiceDiscount);

		if (overrideBranchId) {
			formData.append('initiated_branch_id', overrideBranchId);
		} else {
			const storedBranch = BranchValidator.getStoredTransactionBranch();
			if (storedBranch) {
				formData.append('initiated_branch_id', storedBranch.branchId);
			}
		}

		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}
	refundItem(postObj,paymentList, stateObj, savedItemList, counterEntry, isToggled) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/refund_pos_receipt';
		const formData = new FormData();
		formData.append('profile_id',postObj.profileID);
		formData.append('payment_list',JSON.stringify(paymentList));
		formData.append('discount',postObj.discount);
		formData.append('total_paid',postObj.totalPaid);
		formData.append('total_tendered',postObj.totalTendered);
		formData.append('total_change',postObj.totalChange);
		formData.append('total_gross_amt',postObj.totalGrossAmt);
		formData.append('total_bill',postObj.totalBill);
		formData.append('total_tax1',postObj.totalTax1);
		formData.append('total_tax2',postObj.totalTax2);
		formData.append('total_tax3',postObj.totalTax3);
		formData.append('total_tax',postObj.totalTax);
		formData.append('description',postObj.description);
		formData.append('payment_method',postObj.paymentMethod);
		formData.append('doctor_details',postObj.doctorDetails);
		formData.append('patient_details',postObj.patientDetails);
		formData.append('status',postObj.status);
		formData.append('type',postObj.type);
		formData.append('search_receipt_no',postObj.searchReceiptNo);
		formData.append('transfer_store_id',stateObj.transferStoreID);
		formData.append('item_list',JSON.stringify(savedItemList));
		formData.append('counter_entry',JSON.stringify(counterEntry));
		formData.append('customer_name',stateObj.selectedProfile);
		formData.append('customer_tel',stateObj.customerTel);
		formData.append('is_toggeled', isToggled);
		formData.append('receipt_id', postObj.receiptID);
		formData.append('search_receipt_no', postObj.searchReceiptNo);
		formData.append('remark',postObj.remark);
		
		// Add initiated branch ID for validation
		const storedBranch = BranchValidator.getStoredTransactionBranch();
		if (storedBranch) {
			formData.append('initiated_branch_id', storedBranch.branchId);
		}
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}
	savePurchaseItem(postObj,paymentList,savedItemList,counterEntry) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/save_purchase_receipt';
		const formData = new FormData();
		formData.append('profile_id',postObj.profileID);
		formData.append('payment_list',JSON.stringify(paymentList));
		formData.append('discount',postObj.discount);
		formData.append('total_paid',postObj.totalPaid);
		formData.append('total_tendered',postObj.totalTendered);
		formData.append('total_change',postObj.totalChange);
		formData.append('total_gross_amt',postObj.totalGrossAmt);
		formData.append('total_bill',postObj.totalBill);
		formData.append('total_tax1',postObj.totalTax1);
		formData.append('total_tax2',postObj.totalTax2);
		formData.append('total_tax3',postObj.totalTax3);
		formData.append('total_tax',postObj.totalTax);
		formData.append('description',postObj.description);
		formData.append('payment_method',postObj.paymentMethod);
		formData.append('bill_no',postObj.billNo);
		formData.append('status',postObj.status);
		formData.append('type',postObj.type);
		formData.append('search_receipt_no',postObj.searchReceiptNo);
		formData.append('item_list',JSON.stringify(savedItemList));
		formData.append('counter_entry',JSON.stringify(counterEntry));
		formData.append('total_goods_value',postObj.totalGoodsValue);
		
		// Add initiated branch ID for validation
		const storedBranch = BranchValidator.getStoredTransactionBranch();
		if (storedBranch) {
			formData.append('initiated_branch_id', storedBranch.branchId);
		}

		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}


	returnPurchaseItem(postObj,paymentList,savedItemList,counterEntry) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/return_purchase_receipt';
		const formData = new FormData();
		formData.append('profile_id',postObj.profileID);
		formData.append('payment_list',JSON.stringify(paymentList));
		formData.append('discount',postObj.discount);
		formData.append('total_paid',postObj.totalPaid);
		formData.append('total_tendered',postObj.totalTendered);
		formData.append('total_change',postObj.totalChange);
		formData.append('total_gross_amt',postObj.totalGrossAmt);
		formData.append('total_bill',postObj.totalBill);
		formData.append('total_tax1',postObj.totalTax1);
		formData.append('total_tax2',postObj.totalTax2);
		formData.append('total_tax3',postObj.totalTax3);
		formData.append('total_tax',postObj.totalTax);
		formData.append('description',postObj.description);
		formData.append('payment_method',postObj.paymentMethod);
		formData.append('bill_no',postObj.billNo);
		formData.append('status',postObj.status);
		formData.append('type',postObj.type);
		formData.append('search_receipt_no',postObj.searchReceiptNo);
		formData.append('item_list',JSON.stringify(savedItemList));
		formData.append('counter_entry',JSON.stringify(counterEntry));
		formData.append('total_goods_value',postObj.totalGoodsValue);
		formData.append('receipt_id', postObj.receiptID);
		formData.append('search_receipt_no', postObj.searchReceiptNo);
		formData.append('remark',postObj.remark);
		
		// Add initiated branch ID for validation
		const storedBranch = BranchValidator.getStoredTransactionBranch();
		if (storedBranch) {
			formData.append('initiated_branch_id', storedBranch.branchId);
		}

		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}
	
	getReceiptItems(ReceiptNo) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/search_pos_receipt';
		const formData = new FormData();
		formData.append('receipt_no',ReceiptNo);
		
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}
	
	getPurchaseItems(ReceiptNo) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/search_purchase_receipt';
		const formData = new FormData();
		formData.append('receipt_no',ReceiptNo);
		
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}

	transactionList(postObj,start) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/pos_transaction_list';
		const formData = new FormData();
		formData.append('filters', JSON.stringify(postObj));
		formData.append('start', start);
		
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
		.catch((e) => ExceptionHandling.HandleErrors(e))
		.finally(() => {
			store.dispatch(ActionTypes.PROGRESS_BAR, false);
		})
	}
	transactionSummary(postObj) {
		//console.log("TRANSACTION SUMMARY IN JS")
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
	
		return instance()({
			method: 'post',
			url: '/api/pos_transaction_summary', // New API endpoint
			data: { filters: JSON.stringify(postObj) }
		})
		.then(res => res.data)
		.catch(e => ExceptionHandling.HandleErrors(e))
		.finally(() => {
			store.dispatch(ActionTypes.PROGRESS_BAR, false);
		});
	}
	
	savePayment(postObj,paymentList,counterEntries) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/pos_payments';
		const formData = new FormData();
		formData.append('payment_list', JSON.stringify(paymentList));
		formData.append('counter_list', JSON.stringify(counterEntries));
		formData.append('receipt_id', postObj.id);
		formData.append('type', postObj.type);
		
		// Add initiated branch ID for validation
		const storedBranch = BranchValidator.getStoredTransactionBranch();
		if (storedBranch) {
			formData.append('initiated_branch_id', storedBranch.branchId);
		}
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
		.catch((e) => ExceptionHandling.HandleErrors(e))
		.finally(() => {
			store.dispatch(ActionTypes.PROGRESS_BAR, false);
		})
	}
	
	stockLeft(postObj) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/stock_transfer_status';
		const formData = new FormData();
		formData.append('receipt_id', postObj.id);
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
		.catch((e) => ExceptionHandling.HandleErrors(e))
		.finally(() => {
			store.dispatch(ActionTypes.PROGRESS_BAR, false);
		})
	}
	
	voidStock(postObj) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/transaction_void';
		const formData = new FormData();
		formData.append('receipt_id', postObj.id);
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
		.catch((e) => ExceptionHandling.HandleErrors(e))
		.finally(() => {
			store.dispatch(ActionTypes.PROGRESS_BAR, false);
		})
	}
	
	saveStock(postObj) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/save_transfer_stock';
		const formData = new FormData();
		formData.append('receipt_id', postObj.id);
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
		.catch((e) => ExceptionHandling.HandleErrors(e))
		.finally(() => {
			store.dispatch(ActionTypes.PROGRESS_BAR, false);
		})
	}

	// savePosPurchaseCsv(postObj) {
	// 			////console.log("save junction caled in js");
	// 			//SHOW LOADING
	// 			const store = useStore();
	// 			store.dispatch(ActionTypes.PROGRESS_BAR, true);
	// 			const api = '/api/save_pos_purchase_csv';
	// 			const formData = new FormData();
	// 			formData.append('item_list', JSON.stringify(postObj));
	// 			return instance()(
	// 				{
	// 					method: 'post',
	// 					url: api,
	// 					data: formData,
	// 				}
	// 			).then(res => res.data)
	// 				.catch((e) => ExceptionHandling.HandleErrors(e))
	// 				.finally(() => {
	// 					store.dispatch(ActionTypes.PROGRESS_BAR, false);
	// 				})
	// }

	getReceiptData(receiptID) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/get_pos_receipt';
		const formData = new FormData();
		formData.append('id', receiptID);

		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}
	getTreceiptdata(receiptID, type) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/generate_Treceipt';
		const formData = new FormData();
		formData.append('id', receiptID);
		formData.append('type', type);

		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}

			exportSampleStock(){
				
				const store = useStore();
				store.dispatch(ActionTypes.PROGRESS_BAR, true);
				const api = '/api/export_sample_purchases';
				const formData = new FormData();
				return instance()(
					{
						method: 'post',
						url: api,
						data: formData,
					}
				).then(res => res.data)
					.catch((e) => ExceptionHandling.HandleErrors(e))
					.finally(() => {
						store.dispatch(ActionTypes.PROGRESS_BAR, false);
					})
			}
		
			uploadCSVFile(image) {
				//console.log("upload csv in js");
				//SHOW LOADING
				const store = useStore();
				store.dispatch(ActionTypes.PROGRESS_BAR, true);
				const api = '/api/import_sample_purchases';
				const formData = new FormData();
				formData.append('image', image);
		
				return instance()(
					{
						method: 'post',
						url: api,
						data: formData,
					}
				).then(res => res.data)
					.catch((e) => ExceptionHandling.HandleErrors(e))
					.finally(() => {
						store.dispatch(ActionTypes.PROGRESS_BAR, false);
				})
			}

			save(postObj) {
						////console.log("save junction caled in js");
						//SHOW LOADING
						const store = useStore();
						store.dispatch(ActionTypes.PROGRESS_BAR, true);
						const api = '/api/save_pos_purchase_bulk';
						const formData = new FormData();
						formData.append('item_list', JSON.stringify(postObj));
						return instance()(
							{
								method: 'post',
								url: api,
								data: formData,
							}
						).then(res => res.data)
							.catch((e) => ExceptionHandling.HandleErrors(e))
							.finally(() => {
								store.dispatch(ActionTypes.PROGRESS_BAR, false);
							})
			}

	cashierSessionKeepAlive() {
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/cashier_session_keep_alive';

		return instance()(
			{
				method: 'post',
				url: api
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
		})
	}

	checkBatchFreezeStatus(productId, batchNo) {
		return axios
			.get('/api/stock-freeze/status', {
				params: { product_id: productId, batch_no: batchNo }
			})
			.then(res => res.data)
			.catch(() => ({ frozen: false }));
	}

}